export const ROUTER_PATH_ROOT: string = '/'
export const ROUTER_PATH_INDEX: string = '/home'
export const ROUTER_PATH_LOGIN: string = '/login'
